import { Button, Dialog, Flex, Text } from '@radix-ui/themes';
import React from 'react';

const ErrorPopup = ({ errorMessage, isOpen, onClose }) => {
  // Parse the error message to extract main message and details
  const parseErrorMessage = (message) => {
    const [mainMessage, ...detailsParts] = message.split('\r\nDetails:\r\n');
    const details = detailsParts.length > 0 ? detailsParts[0].split('\r\n').filter(line => line.trim() !== '') : [];
    return { mainMessage, details };
  };

  const { mainMessage, details } = errorMessage ? parseErrorMessage(errorMessage) : { mainMessage: 'An error occurred', details: [] };

  return (
    <Dialog.Root open={isOpen} onOpenChange={onClose}>
      <Dialog.Content maxWidth="450px">
        <Dialog.Title>Error</Dialog.Title>
        <Flex direction="column" gap="3">
          <Text size="3" weight="bold">{mainMessage}</Text>
          {details.length > 0 && (
            <Flex direction="column" gap="1" style={{ marginTop: '8px' }}>
              <Text size="2" weight="medium">Details:</Text>
              {details.map((detail, index) => (
                <Text key={index} size="2" style={{ marginLeft: '8px' }}>
                  • {detail}
                </Text>
              ))}
            </Flex>
          )}
        </Flex>
        <Flex gap="3" mt="4" justify="end">
          <Button onClick={() => onClose(false)}>OK</Button>
        </Flex>
      </Dialog.Content>
    </Dialog.Root>
  );
};

export default ErrorPopup;